import React, { useState } from 'react';
import { Upload, message, Spin } from 'antd';
import { LoadingOutlined, DeleteOutlined } from '@ant-design/icons';
import Cookies from "js-cookie";
import axios from "axios";
import './UnmatchedList.css';

const UnmatchedList = () => {
    const jwtToken = Cookies.get("jwt_token");
    const [file1, setFile] = useState(null);
    const [loadingFileName, setLoadingFileName] = useState('')
    const [uploadSpinLoader, setUploadSpinLoader] = useState(false)

    const handleFileChange = ({ file1: newFileList }) => {
        setFile(newFileList);
    };

    const antIcon = (
        <LoadingOutlined
            style={{
                fontSize: 30,
                color: '#003A8C'
            }}
            spin
        />
    );

    const itemRender = (originNode, file) => {
        let statusColor;
        if (file.status === "done") {
            statusColor = "green";
        } else if (file.status === "error") {
            statusColor = "#f55451";
        }
        let fileExists = false;
        if (file.length > 0) {
            fileExists = true;
        }
        return <>
            <div style={{ color: statusColor, width: "100%", display: "flex", justifyContent: "space-between", backgroundColor: "#f2f8fc", marginTop: "2px", borderRadius: "4px" }}>{fileExists ? file[0].file.name : null}<DeleteOutlined onClick={() => setFile([])} /></div>
        </>;
    };

    const handleUpload = (options) => {

        const { file } = options;
        const formData = new FormData();
        formData.append('file', file);
        setLoadingFileName(file.name)
        setUploadSpinLoader(true)
        axios.post(`${process.env.REACT_APP_BASE_URL}Paychex/UploadUnmatchedNames`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "Access-Control-Allow-Origin": "no-cors",
                Authorization: `Bearer ${jwtToken}`,
            }
        })
            .then((response) => {
                //console.log(response.data);
                const resdata = response.data
                message.success("Uploaded successfully")
                setLoadingFileName('')
                setUploadSpinLoader(false)
            })
            .catch((error) => {
                message.error("Try again...")
                console.error(error);
                setLoadingFileName('')
                setUploadSpinLoader(false)
            });
    };

    return (
        <>
            <div className='unmatched-upload'>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <Upload.Dragger
                        name="file"
                        // width= {130}
                        // height={50}
                        customRequest={handleUpload}
                        onChange={handleFileChange}
                        itemRender={itemRender}
                        fileList={file1}
                        accept=".xls,.xlsx"
                        onRemove={() => setFile([])}
                        className='unmatched-upload'
                        style={{ border: "1px solid #002766", borderRadius: 10 }}
                    >

                        <div className='content'>
                            <img src="./Images/UploadIcon.png" style={{ height: "20px" }}></img>
                            <span style={{ color: "#002766", fontWeight: 500 }}>UnmatchedList Upload</span>
                        </div>


                    </Upload.Dragger>
                    {
                        loadingFileName.length !== 0 && <div>{loadingFileName}</div>
                    }
                </div>
                <div>

                    {uploadSpinLoader &&
                        <div >
                            <Spin indicator={antIcon} />
                        </div>}
                </div>
            </div>
        </>
    )

}
export default UnmatchedList;